/* eslint-disable no-nested-ternary */
import cloneDeep from 'lodash/cloneDeep';
import { EstimateListType } from '../../../../type/estimate/estimate.type';
import { DateFormatter } from '../../../../utilities/date-formatter';
import { MathHelper } from '../../../../utilities/math-helper';
import { UserAgent } from '../../../../utilities/user-agent';
import './estimate-card.scss';

type Props = {
  isCopy?: boolean;
  data: EstimateListType,
  className?: string,
  callback:(data:EstimateListType)=>void,
}

export const EstimateCard = (props: Props) => {
  const {
    data, className, callback, isCopy,
  } = props;

  return (
    <div
      className={`estimate_card ${UserAgent} card_base ${className || ''} ${data.order_flag ? 'order' : ''}`}
      onClick={() => callback(cloneDeep(data))}
    >
      <div className="card_base_row">
        <div>
          <div className="card_info_item">
            <div className="card_info_item__head">
              見積番号
            </div>
            <div className="card_info_item__text">
              {data.estimate_no || '---'}
            </div>
          </div>

          <div className="card_info_item">
            <div className="card_info_item__head">
              案件名
            </div>
            <div className="card_info_item__text emphasis">
              {data.project_name || '---'}
            </div>
          </div>

          <div className="card_info_item">
            <div className="card_info_item__head">
              顧客名
            </div>
            <div className="card_info_item__text">
              {/* FIXME */}
              {'顧客名' || '---'}
            </div>
          </div>

          <div className="card_info_item">
            <div className="card_info_item__head">
              現場名称
            </div>
            <div className="card_info_item__text">
              {data.field_name || '---'}
            </div>
          </div>

          <div className="card_info_item">
            <div className="card_info_item__head">
              案件担当者
            </div>
            <div className="card_info_item__text">
              {data.project_employee_name || '---'}
            </div>
          </div>

          <div className="card_info_item">
            <div className="card_info_item__head">
              作成日
            </div>
            <div className="card_info_item__text">
              {DateFormatter.date2str(data.estimate_dt) || '---'}
            </div>
          </div>

          <div className="card_info_item">
            <div className="card_info_item__head">
              見積金額
            </div>
            <div className="card_info_item__text important">
              {isCopy
                ? data.gokei_kin
                  ? `¥${MathHelper.localStr(Number(data.gokei_kin))}`
                  : '---'
                : data.gokei_zeinuki_kin
                  ? `¥${MathHelper.localStr(Number(data.gokei_zeinuki_kin))}`
                  : '---'}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
